<ngx-select [allowClear]="false" [items]="items" optionValueField="value" optionTextField="name"
    [disabled]="false" [autoClearSearch]="false" [(ngModel)]="percentage" placeholder="Seleccionar Porcentaje"
    (select)="changePercentage($event)">

    <ng-template ngx-select-option-not-found let-input>
        "{{input}}" no encontrado
    </ng-template>

</ngx-select>